import React from "react";
import PropTypes from "prop-types";
import { Input, InputGroup, InputGroupText } from "reactstrap";

/**
 * 列表頁工具列的關鍵字輸入（design system primitive）。
 *
 * 設計稿(DCK-01-02 29:3150／58:14763)的查詢列是「放大鏡 + 輸入框」貼在一起,
 * 跟 <QueryPanel> 那種多欄位的篩選面板是兩種東西 —— 這裡是工具列上的單一關鍵字。
 * 抽出來的理由:使用者管理與工作項目本來各寫一份一模一樣的 InputGroup。
 */
export const SearchInput = ({ value, onChange, placeholder, width = 240 }) => (
  <InputGroup style={{ width }}>
    <InputGroupText className="bg-white border-end-0">
      <i className="bx bx-search text-muted" />
    </InputGroupText>
    <Input
      className="border-start-0 ps-0"
      aria-label={placeholder}
      placeholder={placeholder}
      value={value}
      onChange={(e) => onChange(e.target.value)}
    />
  </InputGroup>
);
SearchInput.propTypes = {
  value: PropTypes.string,
  onChange: PropTypes.func.isRequired,
  // 同時當 placeholder 與無障礙名稱 —— 設計稿沒有可見的欄位標籤
  placeholder: PropTypes.string.isRequired,
  width: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
};

export default SearchInput;
